export const HEX_ADDRESS_PATTERN = /^0x[0-9A-Fa-f]+$/;

export function hexAddressValidator(control: { value: unknown }): { invalidHex: boolean } | null {
    const value = control.value as string | null | undefined;
    if (!value) return null;

    return HEX_ADDRESS_PATTERN.test(value) ? null : { invalidHex: true };
}
